import type { FullDevice } from '@rtkwlf/asset-data-service';
import { useTranslation } from 'react-i18next';

import { useDeviceDetails } from '@apis/asset-data-service/queries/use-device-details';
import type { DefinitionProps } from '@packages/components/definition/definition';
import { Typography } from '@packages/fenrir/components';
import { EMPTY_FIELD_FALLBACK } from 'ae-constants/constants';

import { AssetInformationFieldWrapper } from './asset-information-field-wrapper/asset-information-field-wrapper';

interface AssetInformationFieldProps {
  assetId: string;
  property: keyof Pick<FullDevice, 'id' | 'name' | 'hostname' | 'netbios'>;
  skeletonProps?: DefinitionProps['skeletonProps'];
}

export const AssetInformationField = ({
  assetId,
  property,
  skeletonProps,
}: AssetInformationFieldProps) => {
  const { t } = useTranslation('ads', {
    keyPrefix: 'assetDetails.information',
  });
  const { data: device } = useDeviceDetails(assetId);

  return (
    <AssetInformationFieldWrapper
      assetId={assetId}
      term={t(property)}
      skeletonProps={skeletonProps}
    >
      <Typography variant="body2">
        {device?.[property] ? device[property] : EMPTY_FIELD_FALLBACK}
      </Typography>
    </AssetInformationFieldWrapper>
  );
};
